const t={"en-US":"USD","pt-br":"BRL"},r=({decimal:r=!0,locale:e="pt-br",value:a=""})=>new Intl.NumberFormat(e,{currency:t[e],maximumFractionDigits:r?2:0,minimumFractionDigits:r?2:0,style:"currency"}).format(a);export{r as default};
